/* GR-LV-MENU 2026-10-06 (Claude). The phone menu (<1000px) opens like louisvuitton.com: a full-width white
   curtain dropping from under the header, rows rising in, the burger turning into an X. Measured on LV mobile:
   .lv-mega-menu__wrapper height/opacity 1.4s cubic-bezier(.74,0,0,1); rows slideUpFade 0.5s, delay .5s + i*.05s.
   DESKTOP (>=1000px) IS UNTOUCHED: every method hands back to the inherited Drawer code (= the GR-POPUP-APPLE
   x-drawer patch). Pairs with gr-lv-menu.css and the 3-path hamburger in snippets/icon.liquid.
   ROLLBACK: delete the GR-LVFEEL tags in sections/gr-enhancements.liquid.
   2026-10-07 LEAVING THROUGH THE MENU (owner: "the menu doesnt close smoothly" when a row opens another page): the rows
   lift away, the white curtain stays, and the next page opens under it and lifts it (snippets/gr-menu-handoff.liquid).
   See the block above whenDefined. */
(function () {
  'use strict';
  if (window.__grLvMenu) return;
  window.__grLvMenu = 1;

  var mdUp = window.matchMedia('screen and (min-width: 1000px)');   /* theme 'md', the same line GR-POPUP-APPLE uses */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CURTAIN = 'cubic-bezier(.74,0,0,1)';      /* LV .lv-mega-menu__wrapper, both directions */
  var RISE = 'cubic-bezier(.215,.61,.355,1)';   /* LV ease-out-cubic */
  var D_OPEN = 1400, D_CLOSE = 1400;            /* the one knob if the owner finds it slow */
  var ROW_DELAY = 500, ROW_STEP = 50, ROW_DUR = 500;
  var READY = 300;   /* behavioural clock (focus trap, Escape, dialog:after-show), the same as today */
  var SHUT = { clipPath: 'inset(0px 0px 100% 0px)', opacity: 0 };
  var FULL = { clipPath: 'inset(0px 0px 0% 0px)', opacity: 1 };

  function cssOn() {
    try { return getComputedStyle(document.documentElement).getPropertyValue('--gr-lvm').trim() === '1'; } catch (e) { return false; }
  }
  function part(el, n) { return el.shadowRoot ? el.shadowRoot.querySelector('[part="' + n + '"]') : null; }
  function burger() { return document.querySelector('button[aria-controls="sidebar-menu"]'); }
  function placeUnderHeader(el) {
    var h = document.querySelector('.shopify-section--header');
    var top = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
    el.style.setProperty('--gr-lvm-top', top + 'px');
    el.toggleAttribute('gr-lvm-solo', top < 1);   /* no header on screen = no burger: show the in-panel X */
  }
  function settled(a) { return a.finished.then(function () {}, function () {}); }
  function controls(list, readyMs) {             /* the two members DialogElement uses: .finished and .finish() */
    var all = Promise.all(list.map(settled)).then(function () {});
    return {
      finished: readyMs ? Promise.race([all, new Promise(function (r) { setTimeout(r, reduce.matches ? 0 : readyMs); })]) : all,
      finish: function () { list.forEach(function (a) { try { a.finish(); } catch (e) {} }); }
    };
  }
  /* an interrupted open/close continues from where the curtain is, never jumping to the other end first */
  function curtain(content, to, duration, easing) {
    var from = to === FULL ? SHUT : FULL;
    var mid = content.getAnimations().some(function (a) { return a.id === 'gr-lvm' && a.playState === 'running'; });
    if (mid) {
      var cs = getComputedStyle(content);
      from = { clipPath: (cs.clipPath && cs.clipPath !== 'none') ? cs.clipPath : FULL.clipPath, opacity: cs.opacity };
    }
    content.getAnimations().forEach(function (a) { try { a.cancel(); } catch (e) {} });
    var anim = content.animate([from, to], { duration: reduce.matches ? 1 : duration, easing: easing || CURTAIN, fill: 'both' });
    anim.id = 'gr-lvm';
    return anim;
  }
  /* fill 'backwards' ONLY: opacity 0 exists solely inside an animation's delay. When the animation ends,
     is cancelled, or never runs (JS failed, reduced motion), the row is simply visible. */
  function rows(el) {
    var out = [];
    var items = el.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist > li, .header-sidebar__footer');
    Array.prototype.forEach.call(items, function (item, i) {
      item.getAnimations().forEach(function (a) { if (a.id === 'gr-lvm-row') { try { a.cancel(); } catch (e) {} } });
      if (reduce.matches) return;
      var a = item.animate([{ opacity: 0, transform: 'translateY(1rem)' }, { opacity: 1, transform: 'none' }],
        { duration: ROW_DUR, delay: ROW_DELAY + i * ROW_STEP, easing: RISE, fill: 'backwards' });
      a.id = 'gr-lvm-row';
      out.push(a);
    });
    return out;
  }
  function trap(el, withBurger) {
    try {
      var b = withBurger ? burger() : null;
      if (!withBurger && !el.__grLvmTrap) return;      /* desktop: leave the stock trap exactly as it is */
      el.focusTrap.updateContainerElements(b ? [el, b] : [el]);
      el.__grLvmTrap = !!b;
    } catch (e) {}
  }
  /* theme.js onSidebarBeforeShow writes inline opacity:0 on the main panel (Motion One, 0ms) on every open and only
     revealItems() puts it back. On phones revealItems is a no-op, so clear it here — now, and again after the 0ms
     animation has committed (it lands a frame later under reduced motion). */
  function clearPanel(el) {
    var mp = el.querySelector('.header-sidebar__main-panel');
    if (!mp) return;
    var clr = function () { mp.style.removeProperty('opacity'); mp.style.removeProperty('transform'); };
    clr();
    requestAnimationFrame(function () { requestAnimationFrame(clr); });
  }
  function enter() {
    var el = this, content = part(el, 'content');
    if (!content || !cssOn()) return null;
    placeUnderHeader(el);
    document.documentElement.classList.add('gr-menu-open');
    content.style.marginInlineStart = '0';
    trap(el, true);   /* the burger (now the X) is inside the trap: taps reach the theme's own toggle (theme.js:1653) */
    var c = curtain(content, FULL, D_OPEN);
    c.finished.then(function () { if (el.open) c.cancel(); }, function () {});   /* end state == resting style: no fill residue */
    return controls([c].concat(rows(el)), READY);
  }
  function leave() {
    var content = part(this, 'content');
    if (!content || !cssOn()) return null;
    if (leaving) undo(false);   /* shut while leaving (Escape, a press outside): not leaving any more, rows back, no curtain next */
    return controls([curtain(content, SHUT, quick ? 1 : D_CLOSE)]);   /* honest promise: it gates display:none */
  }
  function afterClose(el, ctl) {
    ctl.finished.then(function () {
      setTimeout(function () {                 /* runs after DialogElement's own display:none */
        if (el.open) return;                   /* re-opened mid-close: keep the open state */
        document.documentElement.classList.remove('gr-menu-open');
        var content = part(el, 'content');
        if (content) content.getAnimations().forEach(function (a) { if (a.id === 'gr-lvm') { try { a.cancel(); } catch (e) {} } });
      }, 0);
    });
  }

  /* ---------- LEAVING THROUGH THE MENU (2026-10-07) ----------
     Owner: "the new animation for the menu opening is great but when clicking on collection to take to another page
     the menu doesnt close smoothly". Before: the curtain stayed frozen open while the next page loaded (Safari stops
     painting the old page the moment a navigation starts), then the new page cut in. LV keeps its menu down while the
     next page loads, then lifts it. Here, on a press of a menu link that loads another page (phone curtain only):
       1 the rows lift away (OUT ms, the pressed row a beat later); a curtain still dropping (a press during the open)
         comes down at once, so the next page opens under exactly this white;
       2 the navigation waits for that (~0.3 s): animations begun inside the click would freeze half-way on Safari.
         Meanwhile the link carries data-gr-hold, which GR-PAGELOAD reads as a held press (assets/gr-pageload.js V10),
         so the gold bar it armed at the press keeps running and the next page continues its clock;
       3 sessionStorage "gr-mnav" tells the next page to open under the same white curtain and lift it with D_CLOSE's
         curve (snippets/gr-menu-handoff.liquid). Without that snippet the next page cuts in, as before.
     While leaving, the burger and the menu ignore presses (a close would show this page again before the next one).
     Back (bfcache) restores this page with the menu shut and the rows in place. Reduced motion: native link, as before.
     Modified / middle clicks, other tabs, other sites, in-page anchors: untouched. */
  var MNAV = 'gr-mnav', OUT = 180, OUT_LAG = 60, CATCH = 200, STALL = 1500, LEAVE_SAFE = 12000;
  var OUT_EASE = 'cubic-bezier(.55,.055,.675,.19)';   /* ease-in cubic: the rows leave the way they rose, reversed */
  var leaving = null, left = false, quick = false;

  function forget() { try { sessionStorage.removeItem(MNAV); } catch (e) {} }
  function leavesPage(a) {             /* GR-PAGELOAD's leaves(): a same-tab load of another document on this site */
    var t = a.getAttribute('target'), raw = a.getAttribute('href') || '', u;
    if ((t && t !== '_self') || a.hasAttribute('download')) return null;
    try { u = new URL(raw, document.baseURI); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (raw.indexOf('#') !== -1 && u.href.split('#')[0] === location.href.split('#')[0]) return null;
    return u;
  }
  /* from wherever each row is (still rising if the press came early), up and out */
  function rowsOut(el, a) {
    var out = [], mine = a.closest('.header-sidebar__linklist > li') || a.closest('.header-sidebar__footer');
    var items = el.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist > li, .header-sidebar__footer');
    Array.prototype.forEach.call(items, function (item) {
      var cs = getComputedStyle(item), from = { opacity: cs.opacity, transform: cs.transform === 'none' ? 'none' : cs.transform };
      item.getAnimations().forEach(function (x) { if (x.id === 'gr-lvm-row' || x.id === 'gr-lvm-out') { try { x.cancel(); } catch (e) {} } });
      var x = item.animate([from, { opacity: 0, transform: 'translateY(-.5rem)' }],
        { duration: OUT, delay: item === mine ? OUT_LAG : 0, easing: OUT_EASE, fill: 'forwards' });
      x.id = 'gr-lvm-out';
      out.push(x);
    });
    return out;
  }
  function catchUp(el) {               /* a curtain still dropping: down now, from where it is (ease-out) */
    var content = part(el, 'content');
    if (!content || !content.getAnimations().some(function (x) { return x.id === 'gr-lvm' && x.playState === 'running'; })) return null;
    var c = curtain(content, FULL, CATCH, RISE);
    c.finished.then(function () { if (el.open) c.cancel(); }, function () {});
    return c;
  }
  function depart(el, a, u) {
    var href = a.href, L = { a: a, anims: [], t: 0, safe: 0, went: false };
    leaving = L; left = true;
    try { sessionStorage.setItem(MNAV, JSON.stringify({ t: Date.now(), u: u.pathname, top: parseInt(el.style.getPropertyValue('--gr-lvm-top'), 10) || 0 })); } catch (e) {}
    a.setAttribute('data-gr-hold', '');
    L.anims = rowsOut(el, a);
    var c = catchUp(el);
    if (c) L.anims.push(c);
    /* a load the browser cancels (Stop; with the Navigation API its navigate signal aborts, as GR-PAGELOAD V1 reads it)
       gives the menu back at once; the navigate event fires synchronously inside assign() */
    var assign = function () {
      var N = window.navigation, hook = null;
      if (N && N.addEventListener) {
        hook = function (ev) {
          N.removeEventListener('navigate', hook);
          if (ev.signal) ev.signal.addEventListener('abort', function () { setTimeout(function () { if (leaving === L) undo(false); }, 0); });
        };
        N.addEventListener('navigate', hook);
      }
      L.at = performance.now();
      location.assign(href);
      if (hook) N.removeEventListener('navigate', hook);
    };
    var go = function () {
      if (leaving !== L || L.went) return;
      L.went = true; clearTimeout(L.t);
      if (document.hidden) { assign(); return; }
      requestAnimationFrame(function () { requestAnimationFrame(function () {   /* the last frame is painted first */
        if (leaving === L) assign();
      }); });
    };
    Promise.all(L.anims.map(settled)).then(go);
    L.t = setTimeout(go, Math.max(OUT + OUT_LAG, c ? CATCH : 0) + 150);   /* never wait on a stalled animation */
    L.safe = setTimeout(function () { if (leaving === L) undo(false); }, LEAVE_SAFE);   /* the load never came */
  }
  function undo(keepFlag) {
    var L = leaving;
    leaving = null;
    if (!L) return;
    clearTimeout(L.t); clearTimeout(L.safe);
    L.a.removeAttribute('data-gr-hold');
    L.anims.forEach(function (x) { if (x.id === 'gr-lvm-out') { try { x.cancel(); } catch (e) {} } });   /* rows back */
    if (!keepFlag) forget();
  }
  /* bfcache: the page is stored (pagehide) and shown again (pageshow) with the menu shut, no animation. The flag is
     kept: the next page may read it after this pagehide. */
  function shutNow() {
    undo(true);
    var el = document.getElementById('sidebar-menu');
    if (el && el.open && !mdUp.matches) {
      quick = true;
      try { el.hide(); } catch (e) {}
      quick = false;
      var content = part(el, 'content');
      if (content) content.getAnimations().forEach(function (x) { if (x.id === 'gr-lvm') { try { x.finish(); } catch (e) {} } });
    }
    if (!el || !el.open) document.documentElement.classList.remove('gr-menu-open');
  }
  addEventListener('pagehide', function (e) { if (e.persisted && leaving) shutNow(); });
  addEventListener('pageshow', function (e) { if (e.persisted && left) { left = false; shutNow(); } });

  /* window bubble = after every other handler, and after GR-PAGELOAD's own bubble listener (head script), which records
     that nobody had prevented this click yet: that is how it tells a held press from a link someone else handled */
  addEventListener('click', function (e) {
    if (leaving || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || reduce.matches) return;
    var el = document.getElementById('sidebar-menu');
    if (!el || !el.open || mdUp.matches || !document.documentElement.classList.contains('gr-menu-open')) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    var u = a && el.contains(a) ? leavesPage(a) : null;
    if (!u) return;
    e.preventDefault();
    depart(el, a, u);
  });
  /* while leaving: no close, no second link. Once the load has stalled STALL ms (stopped where no signal exists: Safari
     18's stop, a 204), the next press is the visitor's again: the X closes the menu, a row starts its own hand-off. */
  addEventListener('click', function (e) {
    var L = leaving;
    if (!L || !e.target || !e.target.closest || !e.target.closest('button[aria-controls="sidebar-menu"], #sidebar-menu')) return;
    if (L.at && performance.now() - L.at > STALL) { undo(false); return; }
    e.preventDefault(); e.stopImmediatePropagation();
  }, true);

  window.customElements.whenDefined('header-sidebar').then(function (Klass) {
    var proto = Klass.prototype;
    if (Object.prototype.hasOwnProperty.call(proto, 'createEnterAnimationControls')) return;   /* theme changed: stand down */
    var parent = Object.getPrototypeOf(proto);   /* Drawer.prototype, looked up at call time, so the GR patch applies */
    var origReveal = proto.revealItems;
    proto.createEnterAnimationControls = function () {
      if (!mdUp.matches) { try { var c = enter.call(this); if (c) return c; } catch (e) {} }
      document.documentElement.classList.remove('gr-menu-open');
      trap(this, false);
      return parent.createEnterAnimationControls.call(this);
    };
    proto.createLeaveAnimationControls = function () {
      var c = null;
      if (!mdUp.matches) { try { c = leave.call(this); } catch (e) { c = null; } }
      if (!c) c = parent.createLeaveAnimationControls.call(this);
      afterClose(this, c);
      return c;
    };
    /* theme.js calls this on dialog:after-show. On phones the rows are already rising from the open itself. */
    proto.revealItems = function (withDelay) {
      if (!mdUp.matches && cssOn()) { clearPanel(this); return { finished: Promise.resolve(), finish: function () {} }; }
      return origReveal.call(this, withDelay);
    };
    /* menu opened on the phone tier, then the screen crosses into desktop while it is open (iPad rotation, window
       resize): the desktop drawer must not inherit the theme's inline opacity:0 (only the <1000px CSS pin hid it) */
    mdUp.addEventListener('change', function (e) {
      var el = document.getElementById('sidebar-menu');
      if (e.matches && el && el.open) clearPanel(el);
    });
    window.addEventListener('resize', function () {
      var el = document.getElementById('sidebar-menu');
      if (el && el.open && !mdUp.matches) placeUnderHeader(el);
    }, { passive: true });
  }).catch(function () {});
})();
